import REQUEST from "@/utils/httpRequest";

export function getUserInfoByToken() {
    return REQUEST({
        url: "/octopus/entuser/infoByToken",
        method: "get"
    }).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/api/user.js